module.exports = __webpack_public_path__ + "img/c-bg-1.84f583e7.png";